import { COMPLETE_REQUIRED_INFO_ABOVE } from 'bento-ordering/menus/constants/ctaName';
/**
 * This method determines if a user made selections on all the
 * required fields. It looks through all variant inputs and make
 * sure every variant meets the selection requirements.
 * Possible Selection scenarios considered:
 * 1) users did not make any selection
 * 2) User made a selection but it it does not meet the min. selection requirement
 * 3) If the selectedfield is a radio button and the user made a selection
 * 4) If the selected fields is a checkbox with some selections
 */

export const getAreRequiredFieldsSelected = (values, fields) => {
  if (fields.length === 0) {
    return true;
  }

  const requiredFieldsAreSelected = fields.every(field => {
    const minQty = parseInt(field.min_qty);
    const selectedField = values[field.slug];
    if (minQty >= 1) {
      /* case 1 */
      if (!selectedField || selectedField === {}) {
        return false;
      }
      /* case 2 */
      if (Object.values(selectedField).length < minQty) {
        return false;
      }
      /* case 3 */
      if (selectedField && typeof selectedField !== 'object') {
        return true;
      }
      /* case 4 */
      if (
        selectedField &&
        typeof selectedField === 'object' &&
        Object.keys(selectedField).length >= minQty
      ) {
        const selectedFieldValues = Object.values(selectedField);
        return selectedFieldValues.filter(value => value).length >= minQty;
      }
    } else {
      return true;
    }
  });
  return requiredFieldsAreSelected;
};

export const getAddToCartLabel = (
  requiredFieldsAreSelected,
  isAddingToCart,
  defaultCtaName,
  isSoldOut
) => {
  if (isSoldOut) {
    return 'SOLD OUT';
  }
  if (isAddingToCart) {
    return 'Adding to cart';
  }

  if (requiredFieldsAreSelected) {
    return defaultCtaName;
  }

  return COMPLETE_REQUIRED_INFO_ABOVE;
};
